import { GlobalReactQueryOptions } from '../../config';
import { useQuery } from '@tanstack/react-query';
import { fetchSelectionListGroupedItems } from './fetchSelectionListGroupedItems';
import { browserClient } from '../../react-query';
import * as types from '../../store/orderlist/types';
import { ErrorResponse, globalErrorResponse } from '../../store/notifications/actions';
import { useDispatch } from 'react-redux';

interface Params {
    enabled: boolean;

    listId: string;
}

const SELECTION_LIST_GROUPED_ITEMS_QUERY_KEY = 'selectionListGroupedItems';

export const useSelectionListGroupedItems = ({ enabled, listId }: Params) => {
    const dispatch = useDispatch();
    return useQuery(
        [SELECTION_LIST_GROUPED_ITEMS_QUERY_KEY, listId],
        () => fetchSelectionListGroupedItems({ listId }),
        {
            ...GlobalReactQueryOptions,
            enabled,
            onError: (error: ErrorResponse) => {
                dispatch({ type: types.SELECTIONLIST_GROUPED_FAILURE });
                dispatch(globalErrorResponse(error));
            }
        }
    );
};

export const invalidateSelectionListGroupedItems = (listId: string) => {
    return browserClient.invalidateQueries([SELECTION_LIST_GROUPED_ITEMS_QUERY_KEY, listId]);
};
